import { css } from '@emotion/react';
import * as React from 'react';
import * as queryString from 'query-string';
import { useLocation } from 'react-router';
import { media } from '../../../ui/global/media-query';
import { ProductI } from '../payment.types';
import { getSubmitButtonLabel } from '../utils/get-submit-button-label';
import { CheckoutDetails } from './checkout-details/checkout-details.component';
import { PaymentMethods } from './payment-methods/payment-methods.component';

interface Props {
  className?: string;
  product: ProductI;
}

export const Checkout: React.FC<Props> = (props) => {
  const { className, product } = props;
  const { search } = useLocation();
  const queryParams = queryString.parse(search, { decode: true });
  const [isBundleAdded, setIsBundleAdded] = React.useState(queryParams['with_bundle'] === 'true');
  const onBundleToggle = (isBundleAdded: boolean) => {
    setIsBundleAdded(isBundleAdded);
  };

  return (
    <div css={wrapperCss} className={className}>
      <div css={contentCss}>
        <div css={leftColumn}>
          <PaymentMethods
            product={product}
            submitButtonLabel={getSubmitButtonLabel(product.__typename)}
            isBundleAdded={isBundleAdded}
          />
        </div>
        {product && <CheckoutDetails product={product} isBundleAdded={isBundleAdded} onBundleToggle={onBundleToggle} />}
      </div>
    </div>
  );
};

const wrapperCss = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  width: 100%;
`;

const contentCss = css`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  gap: 80px;
  width: 100%;
  padding-top: 40px;
  padding-bottom: 40px;
  ${media.medium} {
    flex-direction: column-reverse;
    align-items: center;
    gap: 20px;
    padding-top: 24px;
    padding-bottom: 40px;
  }
`;

const leftColumn = css`
  max-width: 320px;
  flex: 1 1 0%;
  ${media.medium} {
    max-width: 400px;
    width: 100%;
  }
`;
